export default "__VITE_ASSET__06b57b9a__"